import { Injectable } from '@angular/core';
import { jwtDecode } from 'jwt-decode';

@Injectable({
    providedIn: 'root',
})
export class AdminService {
    public getClientIdBasedOnToken(token: string): string {
        if (token === '' || token === null) {
            return '';
        }
        const decoded: any = jwtDecode(token);
        const clientId = decoded['cognito:username'];
        return clientId;
    }
}
